import { render, staticRenderFns } from "./SCoupon.vue?vue&type=template&id=3a5e92c2&scoped=true"
import script from "./SCoupon.vue?vue&type=script&lang=js"
export * from "./SCoupon.vue?vue&type=script&lang=js"
import style0 from "./SCoupon.vue?vue&type=style&index=0&id=3a5e92c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e92c2",
  null
  
)

export default component.exports